const SHOP_DETAILS = "SHOP_DETAILS";
const SHOP_DETAILS_SUCCESS = "SHOP_DETAILS_SUCCESS";
const SHOP_DETAILS_FAILURE = "SHOP_DETAILS_FAILURE";
const CLEAR_SHOP_DETAILS= "CLEAR_SHOP_DETAILS";

const shopDetailsSymbols = {
  SHOP_DETAILS_SUCCESS,
  SHOP_DETAILS_FAILURE,
  SHOP_DETAILS,
  CLEAR_SHOP_DETAILS,
};
export default shopDetailsSymbols;
